<h5 class="p-col-12">Automated Clearing House (ACH) FAQs</h5>
<div class="p-col-12 help-overview-ach">
  <div class="p-col-12">
    <h6>What Is Dwolla?</h6>
    <p>Dwolla is a powerful payments platform that securely connects to bank or credit union accounts to enable the
      transfer of money for any individual or organization in the U.S.</p>
  </div>
  <div class="p-col-12">
    <h6>Why is my transaction still pending?</h6>
    <p>A bank or credit union transaction usually takes 3–4 business days to complete via the Automated Clearing House
      network (ACH) used by banks to transfer funds. Please note that transfers take longer to complete if over a
      weekend or a holiday.</p>
  </div>
  <div class="p-col-12">
    <h6>Why did the transaction fail?</h6>
    Sometimes transactions to or from a bank or credit union can fail. Here are a few reasons why a transaction can fail:
    <ul>
      <li>- <em>Insufficient funds</em> -  There are insufficient funds in the sending bank or credit union account to complete the
        transaction.</li>
      <li>- <em>Frozen account</em> - A bank or credit union account has been frozen.</li>
      <li>- <em>Other reasons</em> - A bank or credit union rejects the transaction for some other reason.</li>
    </ul>
    If a transaction fails, please contact your bank or credit union to check on the status of your account. Then either
    re-initiate the transaction or ask your financial institution why the transaction may not be processed.


  </div>
  <div class="p-col-12">
    <h6>What is Dwolla wallet Balance?</h6>
    <p>Dwolla wallet is a virtual wallet maintained by dwolla to store the funds in case of any failed transactions. Contact support for the
      movement of funds from the dwolla wallet balance.</p>
  </div>
  <div class="p-col-12">
    <h6>Why am I being asked for more documentation?</h6>
    <strong>If we ask for a photo ID:</strong>
    Additional information is needed to verify your identity. Please upload one of the following forms of identification:
    <ul>
      <li>- An unexpired, current, state-issued driver’s license or identification card OR</li>
      <li>- An unexpired, current U.S. passport</li>
    </ul>
    <strong>If we ask for a bank statement:</strong>
    Additional information is needed to verify that you are an authorized signer on your connected bank or credit union account. Please upload a copy of a recent statement.

  </div>
  <div class="p-col-12">
    <h6>How does Dwolla protect customers' data?</h6>
    <p>At Dwolla, we take protecting data seriously. Dwolla maintains compliance with the SOC 2 framework. This framework provides an independent, third-party assurance that we are taking the appropriate steps to protect our systems and your data. Learn more about Dwolla’s security practices <a href="https://www.dwolla.com/security" target="_blank">here</a>.</p>
  </div>
  <div class="p-col-12">
    <h6>How do I contact Dwolla?</h6>
    <ul>
      <li><strong>E-Mail:</strong> <a href="mailto:support@dwolla.com?subject=AtWork Support" target="_blank">support@dwolla.com</a></li>
      <li>​<strong>Phone:</strong> <a href="tel:1-888-289-8744">1-888-289-8744</a></li>
    </ul>
  </div>
</div>
<div class="main-clear">&nbsp;</div>
<h4></h4>
